import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './index.css'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: () => import('./components/MainLayout.vue') },
    { path: '/implementacao-personalizada', component: () => import('./components/CustomImplementation.vue') },
    { path: '/clinicas', component: () => import('./components/Clinicas.vue'), name: 'clinicas' },
    { path: '/imobiliarias', component: () => import('./components/Imobiliarias.vue'), name: 'imobiliarias' },
    { path: '/whitelabel', component: () => import('./components/WhiteLabel.vue'), name: 'whitelabel' },
    { path: '/ligacao-ia', component: () => import('./components/LigacaoIA.vue'), name: 'ligacao-ia' },
    { path: '/demo', component: () => import('./components/DemoIA.vue'), name: 'demo' },
    { path: '/sistemas', component: () => import('./components/Sistemas.vue'), name: 'sistemas' },
    { path: '/revenda', redirect: '/whitelabel' }
  ]
})

const app = createApp(App)

app.use(router)
// @ts-ignore - Bypassing a type definition issue in the vue-tel-input library
app.use(VueTelInput);

app.mount('#root')
